import CloseIconOutline from "$/lib/icons/CloseIconOutline";
import CloudUploadIcon from "$/lib/icons/CloudUploadIcon";

const FileUploaderHeader = () => (
  <div className="flex gap-7">
    <div className="flex size-12 shrink-0 items-center justify-center rounded-full border-2 border-primary-600">
      <CloudUploadIcon height={24} width={24} />
    </div>
    <div className="flex flex-col gap-1">
      <p className="text-start text-lg font-semibold text-primary-600">
        Upload files
      </p>
      <p className="text-start font-medium text-tertiary-500">
        Select and upload the files oof your choice
      </p>
    </div>
    <CloseIconOutline className="ml-auto shrink-0 cursor-pointer" />
  </div>
);

export default FileUploaderHeader;
